import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import bemClassName from '../../utils/bem';
import Loading from '../../UI/Loading';
import { RootState, AppDispatch } from '../../store';
// import { useTokenRefreshService } from '../../utils/authStatus';

import './index.scss';
import { checkAuthStatus } from '../../store/reducers/profile/autorizationStatutsSlice';

const main = bemClassName('main');

const useAppDispatch = () => useDispatch<AppDispatch>();

const Main = ({ children }: React.PropsWithChildren) => {
  const status = useSelector((state: RootState) => state.autorizationStatus.status);
  const isLogin = useSelector((state: RootState) => state.autorizationStatus.isLogin);
  const location = useLocation();
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (location.pathname === '/auth') {
      return;
    }
    if (status === 'idle' && isLogin == null) {
      dispatch(checkAuthStatus());
    }
  }, [dispatch, status, isLogin]);

  if (status === 'loading') {
    return <Loading externalClassName={main('loader')} />;
  }

  return <main className={main()}>{children}</main>;
};

export default Main;
